/* src/app/pages/small-molecule/small-molecule.component.scss */
.center {
  width: 25%;
  margin: 10px auto;
}
.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
button {
  margin-right: 10px;
}
th {
  font-weight: bold;
  background-color: #E6E8EB;
}
table {
  width: 100%;
}
.make-gold {
  background-color: #FAF6E2;
}
.make-red {
  background-color: #F0DDDD;
}
.make-green {
  background-color: #DEEED7;
}
li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}
.mat-fab {
  min-width: 100px;
  min-height: 75px;
}
.badge {
  float: right;
}
.content {
  padding: 5px;
}
.content > mat-card {
  width: 100px;
}
.nolist {
  list-style: none;
}
/*# sourceMappingURL=small-molecule.component.css.map */
